import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./form-control.scss";

/**
 * FormControls are horizontal components that can contain one or more form widgets.
 */
export const FormControl = ({ ...props }) => {
    const className = classNames({
        FormControl: true,
    });

    return (
        <div className={className} {...props}>
            {props.children}
        </div>
    );
};

FormControl.propTypes = {
    /** Child components/content.  */
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
        PropTypes.arrayOf(
            PropTypes.oneOfType([PropTypes.element, PropTypes.string])
        ),
    ]),
};

FormControl.defaultProps = {};
